export interface SnackBarConfig {
  panelClass: string;
  duration?: number;
  iconPath?: any;
}

export const SNACK_BAR_VARIANTS: { [key: string]: SnackBarConfig } = {
  success: {
    panelClass: 'snack-bar-success',
    iconPath: '/assets/check-circle.svg',
    duration: 5000,
  },
  warning: {
    panelClass: 'snack-bar-warning',
    iconPath: '/assets/alert-triangle.svg',
    duration: 3000,
  },
  danger: {
    panelClass: 'snack-bar-danger',
    iconPath: '/assets/delete-white.svg',
    duration: 3000,
  },
  info: {
    panelClass: 'snack-bar-info',
    iconPath: '/assets/info-white.svg',
    duration: 3000,
  },
  error: {
    panelClass: 'snack-bar-danger',
    iconPath: '/assets/alert-triangle.svg',
    duration: 3000,
  },
};
